<sf-global-styler [theme]="'stoneplanner'"></sf-global-styler>
@if (authService.isLoggedIn) {
	<nav class="left printHide">
		<a class="nav-link" routerLink="/measurement-units">Measurement Units</a>
		<a class="nav-link" routerLink="/consumables">Consumables</a>
		<a class="nav-link" routerLink="/store-products">Store Products</a>
		<a class="nav-link" routerLink="/inventory">Inventory</a>
		<a class="nav-link" routerLink="/recipes">Receipes</a>
		<a class="nav-link" routerLink="/meal-plan">Meal Plan</a>
		<a class="nav-link" routerLink="/shopping-list">Shopping List</a>
		<a class="nav-link" routerLink="/family-editor">Family Editor</a>
		<a class="nav-link" routerLink="/meals">Meal Times</a>
		<a class="nav-link logout" (click)="logout()">Logout</a>
	</nav>
}
<div class="content" [class.no-nav]="!authService.isLoggedIn">
	<router-outlet></router-outlet>
</div>
